import axios from 'axios';

import type { Clause, ClausePayload } from '../../@types/types';
import { getRequestAuth } from '../helpers/getRequestAuth';

export const updateClauseInLibrary = async (
  id: string,
  data: ClausePayload,
  authToken: string
): Promise<Pick<Clause, 'id'>> => {
  const auth = await getRequestAuth(authToken);

  const response = await axios({
    method: 'patch',
    url: `${process.env.REACT_APP_API_URL}/clauses-spa-${auth.authProvider}/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.token,
    },
    data,
  });

  return response.data;
};
